import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';
import BrandLogo from './BrandLogo';

function TopNav() {
  const { t } = useLanguage();

  return (
    <nav className="topnav">
      <div className="brand">
        <span className="brand-mark" aria-hidden="true">
          <BrandLogo />
        </span>
        <span className="brand-name">0v network</span>
        <span className="brand-tag">{'// AI gateway'}</span>
      </div>
      <div className="nav-links">
        <LanguageSwitcher />
        <a href="#models">{t('nav.models')}</a>
        <a href="#contact">{t('nav.contact')}</a>
      </div>
      {/* Sibling of .nav-links, not a child, so it can hold row 1 on mobile. */}
      <a className="nav-cta" href="https://app.0v.network/dashboard/overview" target="_blank" rel="noreferrer">
        {t('nav.console')} <span className="arr">→</span>
      </a>
    </nav>
  );
}

export default TopNav;
